const fr = {
  button: {
    admissions: 'Admissions',
    apply: 'Postuler',
    notes: 'Notes',
    back: 'Précédent',
    curatedTour: 'Visites recommandées',
    exploreCampus: 'Explorer près de chez moi',
    personalizedTour: 'Visite personnalisée',
    home: 'Accueil',
    requestInfo: 'Demander informations',
    search: 'Rechercher',
    langSpanish: 'Visualiser en espagnol',
    langEnglish: 'Visualiser en anglais',
    langFrench: 'Visualiser en français',
    langKorean: 'Visualiser en coréen',
    langChineseMandarin: 'Visualiser en chinois',
    continue: 'Continuer',
    cancel: 'Annuler',
    resume: 'Reprendre',
    ok: 'Ok',
    emailMyTour: 'Envoyer ma visite par courriel',
    emailMyNotes: 'Envoyer mes notes par courriel',
    share: 'Partager',
    finishTour: 'Finir visite',
    edit: 'Éditer',
    add: 'Ajouter',
    save: 'Sauvegarder'
  },
  message: {
    tourTheCampus: 'Visiter le campus',
    exploreCampus: '@:button.exploreCampus',
    notFound: 'Non trouvé',
    personalizedTour: '@:button.personalizedTour',
    curatedTour: '@:button.curatedTour',
    nothingError: 'Rien à afficher',
    viewNotes: 'Mes notes',
    continueAbandonedTour: 'Reprendre visite précédente?',
    about: 'À propos de',
    location: 'Lieu | Lieux',
    locations: 'Lieux',
    stops: 'Arrêts',
    congratulations: 'Félicitations !',
    firstName: 'Prénom',
    lastName: 'Nom',
    success: 'Succès',
    listenNow: 'Écouter maintenant',
    restrictedPublicAccess: 'Accès public limité'
  },
  socialMedia: {
    twitter: 'Twitter',
    facebook: 'Facebook',
    email: 'E-mail',
    text: 'SMS/texto'
  },
  curatedTour: {
    description1: 'Nous avons compilé une liste des types de visites du campus les plus courantes auxquelles vous pouvez prendre part.',
    description2: 'Sélectionnez un centre d’intérêt et vous verrez une liste de bâtiments en rapport avec ce centre d’intérêt à visiter',
    startTour: 'Démarrer visite',
    saveTour: 'Enregistrer visite',
    viewRoute: 'Visualiser itinéraire'
  },
  personalizedTour: {
    title: 'Personnaliser votre visite',
    description1: 'Créez votre propre visite du campus en sélectionnant des lieux d’intérêt basés sur vos centres d’intérêt.',
    description2: 'Sélectionnez une catégorie ci-dessous afin de commencer votre visite personnalisée.',
    description3: 'Ajoutez chaque lieu d’intérêt à votre liste, puis sélectionnez « Créer visite ».',
    poiSelected: 'Points d’intérêt sélectionnés',
    createTour: 'Créer visite',
    editList: 'Éditer liste',
    personalizeTour: '@:personalizedTour.title',
    personalizedTour: 'Ma visite personnalisée',
    createText1: 'Créez votre propre visite du campus en sélectionnant des lieux d’intérêt basés sur vos centres d’intérêt.',
    createText2: 'Ajoutez chaque lieu d’intérêt à votre liste, puis sélectionnez « Créer visite ».',
    myTourText1: 'Voici la liste personnalisée de bâtiments et d’installations que vous avez sélectionnés.',
    myTourText2: 'Visualiser le bâtiment pour plus d’informations ou cliquer sur l’icône de la carte pour connaître l’itinéraire.',
    startTour: '@:curatedTour.startTour',
    saveTour: '@:curatedTour.saveTour',
    viewRoute: '@:curatedTour.viewRoute',
    success: '@:message.success',
    firstName: '@:message.firstName',
    lastName: '@:message.lastName',
    tourEmailed: 'Votre visite a été envoyée par courriel.'
  },
  exploreCampus: {
    description1: 'Visitez et trouvez les espaces les plus utilisés par les étudiants, dont les espaces communs, la cafétéria, le stade, les résidences universitaires et bien d’autres',
    description2: 'Visualiser le bâtiment pour plus d’informations ou cliquer sur l’icône de la carte pour connaître l’itinéraire.',
    listView: 'Vue de la liste',
    mapView: 'Vue de la carte'
  },
  notes: {
    title: '@:message.viewNotes',
    description: 'Un ensemble de vos notes durant vos visites. Vous pouvez les visualiser ou les partager par courriel.',
    success: '@:message.success',
    notesEmailed: 'Vos notes ont été envoyées par courriel.',
    firstName: '@:message.firstName',
    lastName: '@:message.lastName',
    enterYourNoteHere: 'Saisir vos notes ici',
    edit: '@:button.edit',
    save: '@:button.save'
  },
  poiView: {
    description: 'Description',
    directions: 'Itinéraire',
    notes: '@:button.notes',
    openMap: 'Carte',
    startTour: 'Emmenez-moi là',
    listStops: 'Lister les arrêts',
    listEmpty: 'La liste est vide',
    priorStop: 'Arrêt précédent',
    nextStop: 'Arrêt suivant'
  },
  about: {
    termSentence1: 'vous permet d’interagir avec les campus de manière significative - à votre guise.',
    termSentence2: 'Voir les bâtiments à proximité, faire la visite recommandée du campus, ou créer votre propre visite personnalisée basée sur vos propres centres d’intérêt.',
    createdPowered: 'Crée et fourni par'
  }
}

export default fr
